










































































































import { AmenityModel, AmenityView, AmenityViewModel } from "@/shared/models/amenities";
import { LanguageView } from "@/shared/models/languages";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component
export default class AmenitiesSelection extends Vue {
  @PropSync("ids") amenityModels?: AmenityModel[];
  @Prop() filter?: (a: AmenityView) => boolean;

  @Action("codebooks/refreshAmenitiesAndGroups")
  refreshAmenitiesAndGroups?: () => Promise<void>;
  @Getter("codebooks/amenities") amenities?: AmenityView[];

  @Action("codebooks/refreshLanguages") refreshLanguages?: () => Promise<void>;
  @Getter("codebooks/languages") languages?: LanguageView[];

  mounted() {
    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      this.refreshLanguages();
    }
  }

  get filteredItems() {
    const f = this.filter ?? (() => true);
    const filtered = this.amenities?.filter(x => {
      if (this.multiSearch.name == undefined) return f(x)
      else {
        return f(x) && (
            this.$t(x.textResourceKey).toString().toLowerCase().includes(this.multiSearch.name.toString().toLowerCase())
          )
      }
    });

    const list: AmenityViewModel[] = [];

    if(filtered)
    {
      filtered.forEach(function (value) {
        const x = new AmenityViewModel();
        x.id = value.id
        x.name = value.name
        x.textResourceKey = value.textResourceKey
        x.amenityGroupId = value.amenityGroupId
        x.amenitySortOrder = value.amenitySortOrder
        x.userShouldSetIsFreeAttribute = value.userShouldSetIsFreeAttribute
        x.userShouldSetIsOnSiteAttribute = value.userShouldSetIsOnSiteAttribute
        x.userShouldSetEmphasizeOnBEAttribute = value.userShouldSetEmphasizeOnBEAttribute
        x.isPropertyLevelAmenity = value.isPropertyLevelAmenity
        x.isAccomodationUnitTypeLevelAmenity = value.isAccomodationUnitTypeLevelAmenity
        x.amenityGroupName = value.amenityGroupName
        x.notes = value.notes

        list.push(x);
      });
    }

    const check = (id: number): AmenityModel | undefined => this.amenityModels?.find((a) => a.amenityId == id);

    let finalList = list.map((g) => {
      const x = new AmenityViewModel();
      x.id = g.id;
      x.name = this.$t(g.textResourceKey).toString();
      x.textResourceKey = g.textResourceKey;
      x.amenityGroupId = g.amenityGroupId;
      x.amenityGroupName = g.amenityGroupName;
      x.amenitySortOrder = g.amenitySortOrder;
      x.userShouldSetIsFreeAttribute = g.userShouldSetIsFreeAttribute
      x.userShouldSetIsOnSiteAttribute = g.userShouldSetIsOnSiteAttribute
      x.userShouldSetEmphasizeOnBEAttribute = g.userShouldSetEmphasizeOnBEAttribute
      x.isPropertyLevelAmenity = g.isPropertyLevelAmenity;
      x.isAccomodationUnitTypeLevelAmenity = g.isAccomodationUnitTypeLevelAmenity;
      x.isSelected = !!check(g.id);
      x.isFree = check(g.id)?.isFree;
      x.isOnSite = check(g.id)?.isOnSite;
      x.emphasizeOnBookingPortal = !!check(g.id)?.emphasizeOnBookingPortal;
      x.notes = check(g.id)?.notes ?? "";

      return x;
    });

    if (this.multiSearch.isSelected) {
      finalList = finalList.filter((x) => x.isSelected)
    }

    if (this.multiSearch.isOnSite) {
      finalList = finalList.filter((x) => x.isOnSite)
    }

    if (this.multiSearch.isFree) {
      finalList = finalList.filter((x) => x.isFree)
    }

    if (this.multiSearch.emphasizeOnBookingPortal) {
      finalList = finalList.filter((x) => x.emphasizeOnBookingPortal)
    }

    return finalList;
  }

  get amenityItems() {
    return this.filteredItems;
  }

  textToTranslate(id: number) {
    return this.filteredItems.find(x => x.amenityGroupId == id)?.amenityGroupName;
  }

  maxLength(max: number) {
    return (v: string) =>
      v.length <= max ? true : this.$t("Validation.MaxLength", { count: max });
  }

  change(item: AmenityViewModel, defaultEmphasizeOnBE?: boolean) {
    const index = this.amenityModels?.findIndex(x => x.amenityId == item.id)
    const data = {
      amenityId: item.id,
      isSelected: item.isSelected,
      notes: item.notes,
      isFree: item.isFree,
      isOnSite: item.isOnSite,
      emphasizeOnBookingPortal: defaultEmphasizeOnBE ?? item.emphasizeOnBookingPortal
    }
    if(index === undefined || index === -1)
    {
      this.amenityModels?.push(data)
    }
    else {
      if(data.isSelected == true)
      {
        this.amenityModels?.splice(index, 1, data);
      }
      else {
        this.amenityModels?.splice(index, 1);
      }
    }
  }

  async created() {
    if (
      (this.amenities?.length ?? 0) === 0 &&
      this.refreshAmenitiesAndGroups
    ) {
      await this.refreshAmenitiesAndGroups();
    }
  }

  get translatedHeaders() {
    return this.headers.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  get translatedSelectItems() {
    return this.selectItems.map((x) => ({
      ...x,
      text: this.$t(x.text),
    }));
  }

  headers = [
    {
      text: 'Selected',
      value: 'isSelected',
      class: 'sticky-header',
      width: '5%',
      groupable: false,
      sortable: false,
    },
    {
      text: "Property.Amenities",
      align: 'start',
      value: 'name',
      class: 'sticky-header',
      width: '30%',
      groupable: false,
      sortable: false,
    },
    {
      text: "Notes",
      align: 'start',
      value: 'notes',
      class: 'sticky-header',
      width: '35%',
      groupable: false,
      sortable: false
    },
    {
      text: 'IsOnSite',
      value: 'isOnSite',
      class: 'sticky-header',
      width: '10%',
      groupable: false,
      sortable: false,
    },
    {
      text: 'IsFree',
      value: 'isFree',
      class: 'sticky-header',
      width: '10%',
      groupable: false,
      sortable: false,
    },
    {
      text: 'OnBookingPortal',
      value: 'emphasizeOnBookingPortal',
      class: 'sticky-header',
      align: 'center',
      width: '10%',
      groupable: false,
      sortable: false,
    },
  ]

  selectItems = [
    {
      text: "Amenity.True",
      value: true
    },
    {
      text: "Amenity.False",
      value: false
    },
    {
      text: "Amenity.Undefined",
      value: null
    },
  ]

  multiSearch: AmenityViewModel = new AmenityViewModel()
}
